
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"14","height":"14","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('mask',{staticStyle:{"mask-type":"alpha"},attrs:{"id":"a","maskUnits":"userSpaceOnUse","x":"0","y":"0","width":"14","height":"14"}},[_c('path',{attrs:{"d":"M5.834 2.334a3.5 3.5 0 100 7 3.5 3.5 0 000-7zm-4.667 3.5A4.667 4.667 0 119.52 8.695l3.143 3.143a.583.583 0 01-.825.825L8.695 9.52a4.667 4.667 0 01-7.528-3.687z","fill":"#0D0D0D"}})]),_c('g',{attrs:{"mask":"url(#a)"}},[_c('path',{attrs:{"fill":"#7A828A","d":"M0 0h14v14H0z"}})])])
          )
        }
      }
    